import { environment } from '../../environments/environment';
import { Match,Sport } from './models/models';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
declare var globalThis: any;

export class Helper {
    static urlParser: HTMLAnchorElement;

    static parseUrl(url: string): any {
        if ((url === void 0) || (url === null)) {
            console.error('Helper.parseUrl invalid argument', url);
            return {};
        }
        if (url.indexOf('//') === 0) {
            url = (globalThis.location && globalThis.location.protocol ? globalThis.location.protocol : 'https:') + url;
        } else if ((url.indexOf('://') === -1) && (url[0] !== '/')) {
            url = '/' + url;
        }
        if (globalThis['urlParser']) {
            return globalThis['urlParser'].parse(url);
        }
        if (!this.urlParser) {
            this.urlParser = globalThis['document'].createElement('A') as any;
        }
        this.urlParser.href = url;
        return this.urlParser;
    }

    static buildUrl(parser: any): string {
        if (globalThis['urlParser']) {
            return globalThis['urlParser'].format(parser);
        }
        return parser.href;
    }

    static applyCdn(url: string, token: 'STCDN'|'STATIC'|'API' = 'STCDN'): string {
        const cdn = this.parseUrl(environment.domains[token as keyof typeof environment.domains ]);
        const cdnHost = cdn.host;
        const cdnProtocol = cdn.protocol;
        const parser = this.parseUrl(url);
        parser.protocol = cdnProtocol;
        parser.host = cdnHost;
        return this.buildUrl(parser);
    }

    static windowScrollY(): number {
        if (typeof globalThis.scrollY !== 'undefined' && globalThis.scrollY >= 0) {
            return globalThis.scrollY;
        }

        if (typeof globalThis.pageYOffset !== 'undefined' && globalThis.pageYOffset >= 0) {
            return globalThis.pageYOffset;
        }

        if (typeof document.body.scrollTop !== 'undefined' && document.body.scrollTop >= 0) {
            return document.body.scrollTop;
        }

        if (typeof document.documentElement.scrollTop !== 'undefined' && document.documentElement.scrollTop >= 0) {
            return document.documentElement.scrollTop;
        }

        return 0;
    }
    static liveState(match: Match, sport: Sport | string | null, fullPeriod: boolean = false): string {
        if ((+match.match_status === -2) && match.period) {
            return match.period.s;
        }
        let str = '';
        if (match.period) {
            if (fullPeriod) {
                str = match.period.n;
            } else {
                str = match.period.s;
            }
        }
        if (match.time_sec) {
            const time = Math.ceil(match.time_sec / 60) + '’';
            if (((typeof sport === 'string' && (sport === "ice_hockey" || sport === "basketball")) || (sport && typeof sport !== 'string' && (sport.id == 2 || sport.id == 3)))) {
                return (str.length ? str + ' ' : '') + time;
            }
            return time
        }
        return str.length ? str : 'Live';
    }
    static isMobile(): boolean {
        const navigator = globalThis.navigator;
        return navigator && (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(navigator.userAgent)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)));
    }
    static isElementInViewport(el: any) {
        const rectTop = el.offsetTop;
        const rectLeft = el.offsetLeft;
        let elW: number;
        let elH: number;
        if (el.getBoundingClientRect) {
            const _r = el.getBoundingClientRect();
            elW = _r.width;
            elH = _r.height;
        } else {
            elW = el.width();
            elH = el.height();
        }

        const screenH = globalThis.innerHeight || globalThis.document.documentElement.clientHeight;
        const screenW = globalThis.innerWidth || globalThis.document.documentElement.clientWidth;

        const yPoint = rectTop - this.windowScrollY() + (elH / 2);
        const xPoint = rectLeft + (elW / 2);
        const inY = (yPoint > 0) && (yPoint < screenH);
        const inX = (xPoint > 0) && (xPoint < screenW);

        return inY && inX;
    };
    static shuffle(array: any[]) {
        let currentIndex = array.length;
        let temporaryValue;
        let randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }
        return array;
    }
    static getNested(route: ActivatedRoute|ActivatedRouteSnapshot, type: string, name: string, defaultValue: any = undefined): any {
        let child:any = route;
        while (child) {
            if ('snapshot' in child) {
                if (child.snapshot[type] && (child.snapshot[type][name] !== undefined)) {
                    return child.snapshot[type][name];
                }
            } else {
                if (child[type] && (child[type][name] !== undefined)) {
                    return child[type][name];
                }
            }
            child = child.firstChild;
        }
        return defaultValue;
    }
}
